import type { NocKPI } from '@/mocks/superAdminDashboard';

interface NocKpiCardProps {
  kpi: NocKPI;
  index: number;
}

const statusConfig: Record<string, { dot: string; bar: string; pulse: string }> = {
  green:  { dot: 'bg-emerald-500', bar: 'bg-emerald-500', pulse: '' },
  yellow: { dot: 'bg-amber-500', bar: 'bg-amber-500', pulse: 'animate-pulse' },
  red:    { dot: 'bg-red-500', bar: 'bg-red-500', pulse: 'animate-pulse' },
};

export default function NocKpiCard({ kpi, index }: NocKpiCardProps) {
  const isPositive = kpi.trend >= 0;
  const st = statusConfig[kpi.status];

  return (
    <div
      className="bg-background-50 border border-background-200 rounded-2xl p-4 hover:border-background-300 transition-all group cursor-pointer"
      style={{ animation: `fadeInUp 0.35s ease-out forwards`, animationDelay: `${index * 50}ms`, opacity: 0 }}
    >
      {/* Status indicator bar at top */}
      <div className={`h-0.5 -mx-4 -mt-4 mb-3 rounded-t-2xl ${st.bar} ${st.pulse}`}></div>

      <div className="flex items-start justify-between mb-2">
        <div className="flex items-center gap-2">
          <div className={`w-2 h-2 rounded-full ${st.dot} ${st.pulse} shrink-0`}></div>
          <p className="text-foreground-500 text-[10px] font-semibold uppercase tracking-wider">{kpi.label}</p>
        </div>
        <div className={`w-7 h-7 rounded-lg bg-background-100 flex items-center justify-center group-hover:scale-110 transition-transform`}>
          <i className={`${kpi.icon} text-foreground-500 text-xs`}></i>
        </div>
      </div>

      <p className="text-foreground-950 text-xl md:text-[22px] font-extrabold tracking-tight leading-none mb-2">{kpi.value}</p>

      <div className="flex items-center gap-1.5">
        <div className={`flex items-center gap-0.5 px-1.5 py-0.5 rounded-md text-[9px] font-bold ${isPositive ? 'bg-emerald-100 text-emerald-600' : 'bg-red-50 text-red-500'}`}>
          <i className={`${isPositive ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} text-[9px]`}></i>
          {Math.abs(kpi.trend)}%
        </div>
        <span className="text-foreground-400 text-[9px]">{kpi.trendLabel}</span>
      </div>
    </div>
  );
}